import React, { useState } from 'react';

interface ImageGalleryProps {
  images: { src: string; alt: string }[];
}

const ImageGallery: React.FC<ImageGalleryProps> = ({ images }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <div style={{ display: 'grid', gap: '1rem' }}>
      <img
        src={images[selectedIndex]?.src}
        alt={images[selectedIndex]?.alt}
        className="gallery-image"
        loading="lazy"
        style={{ width: '100%', minHeight: 360, objectFit: 'cover' }}
      />
      <div className="gallery-grid">
        {images.map((image, index) => (
          <button
            key={image.src}
            type="button"
            onClick={() => setSelectedIndex(index)}
            style={{
              border: index === selectedIndex ? '2px solid var(--color-accent)' : '2px solid transparent',
              borderRadius: 'var(--radius-md)',
              padding: 0,
              cursor: 'pointer',
              overflow: 'hidden',
              background: 'none',
            }}
            aria-label={`Show image ${index + 1}`}
          >
            <img src={image.src} alt={image.alt} className="gallery-image" style={{ height: 140 }} />
          </button>
        ))}
      </div>
    </div>
  );
};

export default ImageGallery;
